import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--bg-secondary)] border-t border-[var(--border)]">
      <div className="container-tight py-12">
        <div className="grid sm:grid-cols-3 gap-8 mb-10">
          {/* Brand */}
          <div>
            <h3 className="text-lg font-bold text-[var(--text-primary)] tracking-tight mb-2">
              M<span className="text-accent">IZ</span>
            </h3>
            <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
              Full Stack Developer crafting digital solutions from Surabaya, Indonesia.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-semibold text-[var(--text-primary)] uppercase tracking-wider mb-3">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {[
                { label: 'About', href: '#about' },
                { label: 'Skills', href: '#skills' },
                { label: 'Projects', href: '#projects' },
                { label: 'Contact', href: '#contact' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-[var(--text-secondary)] hover:text-accent transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-[var(--text-primary)] uppercase tracking-wider mb-3">
              Contact
            </h4>
            <ul className="space-y-2 text-sm text-[var(--text-secondary)]">
              <li>Surabaya, Indonesia</li>
              <li>
                <a
                  href="mailto:inalzaelani2806@gmail.com"
                  className="hover:text-accent transition-colors"
                >
                  inalzaelani2806@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-[var(--border)] text-center">
          <p className="text-xs text-[var(--text-muted)]">
            &copy; {currentYear} Muhammad Inal Zaelani. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
